import { AxiosError } from 'axios';

export interface IErrorWithCode extends Error {
  statusCode: number;
  report?: boolean;
}

interface IErrorExtra {
  report?: boolean;
  [key: string]: any;
}

/**
 * Creates an error object with `statusCode` as a property
 */
export const errorWithCode = (
  statusCode: number,
  message: string,
  extraObj: IErrorExtra = {},
): IErrorWithCode => {
  const error = new Error(message);
  error.message = message;
  return Object.assign(error, { statusCode }, extraObj);
};

export default errorWithCode;

export function shouldReport(error: Error | IErrorWithCode) {
  if ((error as any).report !== false) return true;
  // if ((error as any).statusCode === 500) return true;
  return false;
}

/**
 * Creates an errorWithCode from Auth0 Error
 */
export function fromAuth0Error(error: AxiosError | Error) {
  if ('response' in error) {
    const { response: axiosResponse } = error;
    if (axiosResponse) {
      const { data } = axiosResponse;
      const message = (data && (data.error_description || data.description)) || error.message;
      const doNotReportErrors = [
        'Please verify your email before logging in.',
        'Wrong email or password.',
      ];
      return errorWithCode(axiosResponse.status, message, {
        report: !doNotReportErrors.includes(message),
        extra: axiosResponse.data,
      });
    }
  }
  return error;
}
